module.exports = __webpack_public_path__ + "img/step4.afc4ee4a.png";